import { Typography } from '@mui/material'

export default function Logo() {
  return (
    <div style={{ gap: 6, textDecoration: 'none', color: 'inherit', display: 'flex', alignItems: 'center' }}>
      <img style={{ height: 28, width: 28 }} src='/favicon.svg' alt='evaro' />
      <Typography color='primary' fontWeight={700} fontSize={19}>
        Support
      </Typography>
    </div>
  )
}
